import { Typography } from "antd";
import Image from "next/image";
import { useEffect } from "react";
import { useIntl } from "react-intl";
import { _eventBus } from "../../../core/events/EventBus";
import { bookingTree } from "../../../Orchestrator/ConstantTree";
import { useRecState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IBookingResponse } from "../../../Orchestrator/Types/Index";

interface BookingStatusProps {}

const BookingStatus = ({}: BookingStatusProps) => {
  const intl = useIntl();

  const [bookingConfirmStatus] = useRecState<string>(
    "bookingConfirmStatusAtom"
  );
  const [booking] = useRecState<IBookingResponse>("bookingResponseAtom");

  useEffect(() => {
    if (booking) {
      // This event is register into TobBar flow because, TopBar Flow  is alway ruining
      _eventBus.emit({
        eventName: bookingTree.Details.Status.Get,
        data: { booking: booking },
      });
    }
  }, [booking]);

  if (bookingConfirmStatus === "FULFILLED") {
    return (
      <div className="align-items-center">
        <Typography.Text className="fs-14 fw-700 confirm-color mr-10">
          {intl.formatMessage({ id: "confirmedText" })}
        </Typography.Text>
        <Image
          src={"/assets/booking/check_circle.svg"}
          height={20}
          width={20}
          alt="booking confirm"
        />
      </div>
    );
  }
  if (bookingConfirmStatus === "REFUNDED") {
    return (
      <div className="align-items-center">
        <Typography.Text className="fs-14 fw-700 cancel-color mr-10">
          {intl.formatMessage({ id: "cancelledText" })}
        </Typography.Text>
        <Image
          src={"/assets/booking/times-circle.svg"}
          height={20}
          width={20}
          alt="booking cancel"
        />
      </div>
    );
  }
  if (bookingConfirmStatus === "PAST") {
    return (
      <div className="align-items-center">
        <Typography.Text className="fs-14 fw-700 confirm-color mr-10">
          {intl.formatMessage({ id: "pastText" })}
        </Typography.Text>
        <Image
          src={"/assets/booking/check_circle.svg"}
          height={20}
          width={20}
          alt="booking confirm"
        />
      </div>
    );
  }
  return <></>;
};

export default BookingStatus;
